import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { logInvalidFieldsToGtmEvent } from 'services/gtm/gtmEvents';

const FormikErrorsGtmLogger = ({
  page_type,
  form_type,
}: {
  page_type: string;
  form_type: string;
}): null => {
  const { errors, isSubmitting } = useFormikContext();

  useEffect(() => {
    if (isSubmitting && Object.keys(errors).length > 0)
      logInvalidFieldsToGtmEvent({
        page_type,
        form_type,
        errorsKeys: Object.keys(errors),
      });
  }, [isSubmitting]);

  return null;
};

export default FormikErrorsGtmLogger;
